import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { BdState } from '@bindoc-projects/geographic-domain-lib';
import {
  BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT,
  BdMapsStateSelectOptions,
} from '../../select-options';
import { BdMapsStateSelectSingleHandler } from '../../single-select-handler';
import { BdMapsStateAbstractSelectList } from '../abstract-select-list';

@Component({
    selector: 'bd-maps-state-select-list-single',
    template: `
    <div>
      <div class="flex flex-row flex-wrap">
        @for (
          stateOption of selectionHandler.statesOptions;
          track stateOption
        ) {
          <div class="basis-full md:basis-1/2 xl:basis-60">
            <div class="flex flex-row items-center gap-2">
              <p-checkbox
                [inputId]="'maps-state-select-single-' + stateOption.id"
                [binary]="true"
                [ngModel]="isChecked(stateOption)"
                (onChange)="onCheckboxChange(stateOption)"
              />
              <label [for]="'maps-state-select-single-' + stateOption.id">{{
                stateOption?.name
              }}</label>
            </div>
          </div>
        }
      </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Checkbox, FormsModule]
})
export class BdMapsStateSelectListSingleComponent
  extends BdMapsStateAbstractSelectList<BdState>
{
  readonly states = input<BdState[]>();
  readonly initialStateId = input<number>();
  readonly options = input<BdMapsStateSelectOptions>(BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT);
  readonly stateSelect = output<BdState | null>();

  public override selectionHandler = new BdMapsStateSelectSingleHandler();

  constructor() {
    super();

    this.selectionHandler.statesSelect$.subscribe((resource) => {
      this.stateSelect.emit(resource);
    });

    effect(() => {
      const states = this.states();
      if (states) {
        this.selectionHandler.states = states;
      }
    });

    effect(() => {
      const initialStateId = this.initialStateId();
      if (initialStateId !== undefined) {
        this.selectionHandler.initialStateId = initialStateId;
      }
    });

    effect(() => {
      const opts = this.options();
      if (opts) {
        this.selectionHandler.options = opts;
      }
    });
  }

  public onCheckboxChange(state: BdState) {
    this.selectionHandler.updateSelection(state);
  }

  public isChecked(state: BdState): boolean {
    if (this.selectionHandler.selectedResources) {
      return this.selectionHandler.selectedResources.id === state.id;
    } else {
      return false;
    }
  }
}
